export default __webpack_public_path__ + "static/media/real_reward.f9ea1265.svg";